import React from 'react';
import classnames from 'classnames';
import { TableRow, Tooltip } from '@getsynapse/design-system';
import { Link } from 'react-router-dom';
import { ProjectDrillDownItem } from 'types/store/normalized/insightsDrillDown';
import get from 'lodash/get';
import { getUserAvartarColumn } from '../../helpers';
import { getStatusColumn } from '../../../../Pages/ProjectsListPage/helpers/tableColumnsValues';
import { titleToSnakeCase } from 'utils/functions/dashboard';
import moment from 'moment';
import { DATE } from 'utils/constants';

type ProjectDrillDownTableRowProps = {
  item: ProjectDrillDownItem;
  readOnly: boolean;
};

const ProjectDrillDownTableRow: React.FC<ProjectDrillDownTableRowProps> = ({
  item,
  readOnly,
}) => {
  return (
    <TableRow
      id={item.id}
      className='group cursor-pointer'
      cells={[
        {
          content: (
            <>
              {readOnly ? (
                item.project_number
              ) : (
                <Link
                  to={`/project/${item.id}`}
                  className='text-steel-blue underline'
                >
                  {item.project_number || ''}
                </Link>
              )}
            </>
          ),
        },
        { content: item.title },
        {
          content: (
            <div>{getStatusColumn(titleToSnakeCase(item.project_status))}</div>
          ),
        },
        { content: item.project_priority },
        {
          content:
            item.owners?.length > 0 &&
            getUserAvartarColumn(
              item.owners.map((i) => ({
                avatar_url: get(i, 'avatar_url') || undefined,
                status: get(i, 'status'),
                data: {
                  firstName: get(i, 'first_name'),
                  lastName: get(i, 'last_name'),
                  email: get(i, 'email'),
                },
              }))
            ),
        },
        { content: item.project_health },
        {
          content: (
            <Tooltip
              openMode='hover1'
              position='topCenter'
              contentProps={{
                className: classnames(
                  'bg-neutral-darker shadow-tooltip',
                  'rounded-lg px-4 py-3',
                  'absolute',
                  'w-max whitespace-normal',
                  'text-body',
                  'z-50'
                ),
              }}
              timeout={0}
              showPopper
              className={`w-full truncate`}
              trigger={
                <span>
                  {(
                    (item.business_units || [])
                      .map((i) => i.title)
                      .join(', ') || 'N/A'
                  ).length > 40
                    ? (item.business_units || [])
                        .map((i) => i.title)
                        .join(', ')
                        .substring(0, 40) + '...'
                    : (item.business_units || [])
                        .map((i) => i.title)
                        .join(', ') || 'N/A'}
                </span>
              }
            >
              {(item.business_units || []).map((i) => i.title).join(', ') ||
                'No business units'}
            </Tooltip>
          ),
        },
        { content: item.total_demand_hours },
        { content: item.category_name },
        {
          content: (
            <Tooltip
              openMode='hover1'
              position='topCenter'
              contentProps={{
                className: classnames(
                  'bg-neutral-darker shadow-tooltip',
                  'rounded-lg px-4 py-3',
                  'absolute',
                  'w-max whitespace-normal',
                  'text-body',
                  'z-50'
                ),
              }}
              timeout={0}
              showPopper
              className={`w-full truncate`}
              trigger={
                <span>
                  {(item.programs || []).map((i) => i.title).join(', ') ||
                    'N/A'}
                </span>
              }
            >
              {(item.programs || []).map((i) => i.title).join(', ') ||
                'No Programs'}
            </Tooltip>
          ),
        },
        {
          content: item.start_date && (
            <div>
              {moment(new Date(item.start_date)).format(DATE.SHORT_FORMAT)}
            </div>
          ),
        },
        {
          content: item.target_completion_date && (
            <div>
              {moment(new Date(item.target_completion_date)).format(
                DATE.SHORT_FORMAT
              )}
            </div>
          ),
        },
        {
          content: item.completion_date && (
            <div>
              {moment(new Date(item.completion_date)).format(DATE.SHORT_FORMAT)}
            </div>
          ),
        },
        { content: item.resourcing_type },
        { content: item.process_name },
        { content: item.stage_name },
      ]}
    />
  );
};

export default ProjectDrillDownTableRow;
